import React, { useState, useMemo } from 'react';

import moment from 'moment';
import * as Yup from 'yup';

import { Report } from '~/components';
import {
  DateTime,
  Autocomplete,
  RadioGroup,
  Input,
  Select,
  MultiAutocomplete,
} from '~/components/Form';
import { MODULO_20_GRAUS } from '~/constants/modules';
import { t, can } from '~/helpers';

function Relresumooperacao() {
  const [open, setOpen] = useState(true);
  const [resumo, setResumo] = useState('M');
  const [tipoData, setTipoData] = useState(false);
  const [valuePosto, setValuePosto] = React.useState([]);

  const optionsTypeAgroup = useMemo(
    () => [
      { label: 'Turno', value: 'turno' },
      { label: 'Dia', value: 'dia' },
    ],
    []
  );

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });
  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  function handleSerializeForm(params) {
    // const idPosto =  valuePosto === 0 ? '' : valuePosto.map((posto) => posto.idposto);
    const idPosto = valuePosto.idposto === null ? '' : valuePosto.idposto;
    const idProduto = params.idproduto === null ? '' : params.idproduto;

    return {
      ...params,
      idposto: idPosto,
      idproduto: idProduto,
    };
  }

  async function handleValidate(param) {
    try {
      console.log(param);
      const schema = Yup.object().shape({
        unidadecomboio: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .nullable(),
        idproduto: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .nullable(),
        mes:
          resumo === 'M' &&
          Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
      });

      await schema.validate(param, {
        abortEarly: false,
      });
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      }
    }
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.relatorio.resumodaoperacao')}
      relatorio="resumooperacao"
      serialize={(param) => handleSerializeForm(param)}
      validate={(param) => handleValidate(param)}
      initials={{
        datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),
        resumo: 'M',
        mes: (moment().month() + 1).toString(),
        ano: end.format('YYYY'),
        agruparrel: 'turno',
      }}
    >
      <Select
        label="Resumo"
        name="resumo"
        options={[
          { value: 'M', label: t('s.relatorio.geral.mensal') },
          { value: 'P', label: t('s.relatorio.geral.periodo') },
        ]}
        getValue={(value) => setResumo(value)}
      />

      {resumo === 'P' && (
        <>
          <DateTime
            label={t('s.geral.opcoes.datahorainicial')}
            name="datahorainicial"
            time
          />

          <DateTime
            label={t('s.geral.opcoes.datahorafinal')}
            name="datahorafinal"
            serialize={(value) =>
              value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
            }
            time
          />
        </>
      )}

      {resumo === 'M' && (
        <>
          <Select
            label="mes"
            name="mes"
            options={[
              { value: '1', label: t('s.geral.opcoes.janeiro') },
              { value: '2', label: t('s.geral.opcoes.fevereiro') },
              { value: '3', label: t('s.geral.opcoes.marco') },
              { value: '4', label: t('s.geral.opcoes.abril') },
              { value: '5', label: t('s.geral.opcoes.maio') },
              { value: '6', label: t('s.geral.opcoes.junho') },
              { value: '7', label: t('s.geral.opcoes.julho') },
              { value: '8', label: t('s.geral.opcoes.agosto') },
              { value: '9', label: t('s.geral.opcoes.setembro') },
              { value: '10', label: t('s.geral.opcoes.outubro') },
              { value: '11', label: t('s.geral.opcoes.novembro') },
              { value: '12', label: t('s.geral.opcoes.dezembro') },
            ]}
          />

          <Input label="ano" name="ano" type="number" />
        </>
      )}

      <Autocomplete
        name="unidadecomboio"
        label="codigonomeposto"
        url="postoscomboios"
        unique="idposto"
        title={t('s.menu.configuracao.posto')}
        defaultValue=""
        hiddens={[{ name: 'idposto' }, { name: 'nomeposto' }]}
        getValue={(value) => {
          setValuePosto(value);
        }}
      />
      {/* <MultiAutocomplete
        multiple
        name="unidadecomboio"
        label="codigonomeposto"
        url="postoscomboios"
        unique="idposto"
        title={t('s.menu.configuracao.posto')}
        hiddens={[{ name: 'idposto' }, { name: 'nomeposto' }]}
        getValue={(value) => {
          setValuePosto(value);
        }}
      /> */}

      <Autocomplete
        name="idproduto"
        label="nomeproduto"
        url="produtos"
        unique="idproduto"
        title={t('s.menu.configuracao.produto')}
        // first={[{ nomeproduto: 'Todos', value: '' }]}
        defaultValue=""
        hiddens={[{ name: 'nomeproduto' }]}
      />

      {/* <RadioGroup
        name="tipo"
        label={t('s.configuracao.produto.tipoproduto')}
        options={[
          { label: t('s.relatorio.geral.manifestado'), value: 'Manifestado' },
          { label: t('s.relatorio.geral.recebido'), value: 'Recebido' },
        ]}
        defaultValue="Recebido"
        serialize={(value) => value}
        row
      /> */}

      {can(MODULO_20_GRAUS) && (
        <RadioGroup
          name="tiporelatorio"
          label={t('s.relatorio.geral.tiporelatorio')}
          options={[
            {
              label: t('s.relatorio.geral.ambiente'),
              value: 'ambiente',
            },
            {
              label: t('s.relatorio.geral.20graus'),
              value: '20graus',
            },
          ]}
          defaultValue="ambiente"
          serialize={(value) => value}
          row
        />
      )}

      <RadioGroup
        row
        name="agruparrel"
        label="Agrupar"
        options={optionsTypeAgroup}
        style={{ marginBottom: '1.5rem' }}
      />

      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Relresumooperacao;
